type LocationCoords = {
  latitude: number;
  longitude: number;
  accuracy: number | null;
  speed: number | null;
};

export type LocationObject = {
  coords: LocationCoords;
  timestamp: number;
};

type PermissionResult = {
  status: 'granted' | 'denied';
};

export const Accuracy = {
  Balanced: 3,
  High: 4,
} as const;

function browserLocation(): Promise<LocationObject> {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is unavailable in this browser.'));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) =>
        resolve({
          coords: {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            accuracy: position.coords.accuracy,
            speed: position.coords.speed,
          },
          timestamp: position.timestamp,
        }),
      (error) => reject(error),
      { enableHighAccuracy: true },
    );
  });
}

export async function requestForegroundPermissionsAsync(): Promise<PermissionResult> {
  try {
    await browserLocation();
    return { status: 'granted' };
  } catch {
    return { status: 'denied' };
  }
}

export async function requestBackgroundPermissionsAsync(): Promise<PermissionResult> {
  return { status: 'denied' };
}

export function getCurrentPositionAsync(_options?: unknown): Promise<LocationObject> {
  return browserLocation();
}

export async function hasStartedLocationUpdatesAsync(_taskName?: string): Promise<boolean> {
  return false;
}

export async function startLocationUpdatesAsync(_taskName?: string, _options?: unknown): Promise<void> {
  throw new Error('Background location updates are unavailable in the browser demo.');
}

export async function stopLocationUpdatesAsync(_taskName?: string): Promise<void> {}
